<template>
  <v-card class="mt-5 mx-5" id="listener_controllo_qualita">
    <v-toolbar
      color="indigo"
      dense
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title class="white--text">
        Esecuzioni Autocontrolli
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- Input della data da -->
      <v-menu
        v-model="calendario_data_da"
        :close-on-content-click="false"
        :nudge-right="40"
        min-width="289"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <div
            class="mr-5"
            style="
              border: 1px solid black;
              display: inline-block;
              background-color: white;
              padding: 3px;
            "
          >
            <v-text-field
              background-color="#ffffff"
              class="custom-label-color"
              color="white"
              dense
              hide-details
              label="Data Da"
              v-model="data_da_formattata"
              readonly
              style="max-width: 100px"
              v-on="on"
            >
            </v-text-field>
          </div>
        </template>
        <v-date-picker
          v-model="data_da"
          @input="calendario_data_da = false"
        ></v-date-picker>
      </v-menu>

      <!-- Input della data a -->
      <v-menu
        v-model="calendario_data_a"
        :close-on-content-click="false"
        :nudge-right="40"
        min-width="289"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <div
            class="mr-5"
            style="
              border: 1px solid black;
              display: inline-block;
              background-color: white;
              padding: 3px;
            "
          >
            <v-text-field
              background-color="#ffffff"
              class="custom-label-color"
              color="white"
              dense
              hide-details
              label="Data A"
              v-model="data_a_formattata"
              readonly
              style="max-width: 100px"
              v-on="on"
            >
            </v-text-field>
          </div>
        </template>
        <v-date-picker
          v-model="data_a"
          @input="calendario_data_a = false"
        ></v-date-picker>
      </v-menu>

      <!-- Bottone di ricerca -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="getAutocontrolli()"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-magnify </v-icon>
          </v-btn>
        </template>
        <span>Cerca</span>
      </v-tooltip>

      <!-- Bottone di aggiunta riga autocontrollo -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="clickAggiungiAutocontrollo()"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Autocontrollo</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Filtri (mostra campi) -->
      <v-tooltip bottom v-if="filtri_visible === false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="filtri_visible = true"
            small
            v-bind="attrs"
            v-on="on"
            ><v-icon color="purple lighten-2">mdi-filter</v-icon></v-btn
          >
        </template>
        <span>Filtri</span>
      </v-tooltip>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mr-5" @click="ripristina" small v-bind="attrs" v-on="on"
            ><v-icon color="purple lighten-2">mdi-filter-off</v-icon></v-btn
          >
        </template>
        <span>Ripristina</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone per tornare indietro -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :headers="headers_registrazioni"
        :items="items_registrazioni"
        height="70vh"
      >
        <template v-slot:top>
          <v-row align="center" justify="center" v-if="filtri_visible">
            <!-- Filtro del codice commessa -->
            <v-col cols="2">
              <v-autocomplete
                @change="filtra"
                :items="items_registrazioni"
                :item-text="(e) => e.cod_commessa"
                item-value="cod_commessa"
                label="Cod. Commessa"
                v-model="cod_commessa_search"
              >
                <template slot="append">
                  <v-icon
                    @click="
                      cod_commessa_search = '';
                      filtra();
                    "
                    color="primary"
                  >
                    mdi-filter-off
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Filtro del codice articolo -->
            <v-col cols="2">
              <v-autocomplete
                @change="filtra"
                :items="
                  items_registrazioni.filter((e) => e.cod_articolo != null)
                "
                :item-text="(e) => e.cod_articolo"
                item-value="cod_articolo"
                label="Cod. Articolo"
                v-model="cod_articolo_search"
              >
                <template slot="append">
                  <v-icon
                    @click="
                      cod_articolo_search = '';
                      filtra();
                    "
                    color="primary"
                  >
                    mdi-filter-off
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Filtro della descrizione fase -->
            <v-col cols="2">
              <v-autocomplete
                @change="filtra"
                :items="items_registrazioni.filter((e) => e.des != null)"
                :item-text="(e) => e.des"
                item-value="des_fase"
                label="Des. Fase"
                v-model="des_fase_search"
              >
                <template slot="append">
                  <v-icon
                    @click="
                      des_fase_search = '';
                      filtra();
                    "
                    color="primary"
                  >
                    mdi-filter-off
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Filtro della validazione -->
            <v-col cols="2">
              <v-autocomplete
                @change="filtra"
                :items="items_registrazioni"
                :item-text="
                  (e) =>
                    e.conforme === null
                      ? 'indefinito'
                      : e.conforme === 1
                      ? 'approvato'
                      : 'respinto'
                "
                item-value="conforme"
                label="Conformità"
                v-model="conforme_search"
              >
                <template slot="append">
                  <v-icon
                    @click="
                      conforme_search = 2;
                      filtra();
                    "
                    color="primary"
                  >
                    mdi-filter-off
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </template>

        <!-- Colonna della data -->
        <template v-slot:[`item.data_controllo`]="{ item }">
          {{
            item.data_controllo != null
              ? `${item.data_controllo.substring(
                  8,
                  10
                )}/${item.data_controllo.substring(
                  5,
                  7
                )}/${item.data_controllo.substring(
                  0,
                  4
                )} - ${item.data_controllo.substring(
                  11,
                  13
                )}:${item.data_controllo.substring(14, 16)}`
              : "N/D"
          }}
        </template>

        <!-- Colonna della data -->
        <template v-slot:[`item.esito`]="{ item }">
          <v-icon
            :color="
              (item.valore === null && item.misura === 1) ||
              (item.valore != null &&
                item.valore_max >= item.misura &&
                item.misura >= item.valore_min)
                ? 'success'
                : 'error'
            "
            large
          >
            {{
              (item.valore === null && item.misura === 1) ||
              (item.valore != null &&
                item.valore_max >= item.misura &&
                item.misura >= item.valore_min)
                ? "mdi-check"
                : "mdi-close"
            }}
          </v-icon>
        </template>

        <!-- Colonna della conformità -->
        <template v-slot:[`item.conforme`]="{ item }">
          <v-icon
            :color="item.conforme === 1 ? 'success' : 'grey'"
            @click="$set(item, 'conforme', 1)"
          >
            {{
              item.conforme === 1
                ? "mdi-checkbox-marked"
                : "mdi-checkbox-blank-outline"
            }}
          </v-icon>
          <v-icon
            :color="
              item.conforme === 0 ||
              item.conforme === null ||
              item.conforme === undefined
                ? 'primary'
                : 'grey'
            "
            @click="$set(item, 'conforme', 0)"
          >
            {{
              item.conforme === 0 ||
              item.conforme === null ||
              item.conforme === undefined
                ? "mdi-checkbox-intermediate"
                : "mdi-checkbox-blank-outline"
            }}
          </v-icon>
        </template>
        <!-- :style="{
              backgroundImage: `url('${item.img}')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: contain,
              border: '1px solid black',
              height: '100px',
              marginTop: 5px,
              position: 'relative',
              width: '100px',
            }"-->
        <!-- Spazio per la miniatura della foto da webcam -->
        <template v-slot:[`item.img`]="{ item }">
          <v-tooltip bottom v-if="item.image == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickDettaglioImmagine(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>Dettaglio immagine</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Dialog di visualizzazione dell'immagine -->
    <v-dialog v-model="dettaglio_immagine_visible">
      <Controllo
        :clear_on_save="false"
        :immagine_standard_editor="img_sel != null ? img_sel : ''"
        :show_close_button="false"
        :show_editor_tool_columns="false"
        :show_editor_save_button="false"
        :tabella_supporto="''"
        :titolo_editor="`Immagine Associata`"
        v-if="dettaglio_immagine_visible"
        :visible="true"
      />
    </v-dialog>

    <!-- Dialog di aggiunta riga autocontrolli -->
    <v-dialog v-model="dialog_aggiungi_autocontrolli" persistent width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Aggiunta Riga Autocontrolli
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaRigaAutocontrolli"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Riga</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_aggiungi_autocontrolli = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="max-width: 900px; overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <!-- Data controllo -->
              <v-col cols="3">
                <v-menu
                  v-model="calendario_data_controllo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      background-color="#ffffff"
                      dense
                      hide-details
                      label="Data Controllo"
                      outlined
                      v-model="data_controllo_formattata"
                      readonly
                      style="border-radius: 0px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    first-day-of-week="1"
                    locale="it"
                    v-model="data_controllo_tmp"
                    @input="calendario_data_controllo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="3">
                <v-menu
                  v-model="calendario_ora_controllo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      hide-details
                      v-model="ora_controllo_tmp"
                      label="Ora Controllo"
                      outlined
                      readonly
                      style="border-radius: 0px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    format="ampm"
                    v-model="ora_controllo_tmp"
                    full-width
                    @click:minute="calendario_ora_controllo = false"
                  ></v-time-picker>
                </v-menu>
              </v-col>

              <v-col justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Commessa"
                  v-model="cod_commessa_tmp"
                  v-on:keydown.enter="cercaCommesse"
                >
                  <template v-slot:append-outer>
                    <v-btn @click="cercaCommesse" small>
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Fase"
                  readonly
                  v-model="cod_fase_tmp"
                >
                  <template v-slot:append-outer>
                    <v-btn @click="getCicliSelezionabili" small>
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Caratteristica"
                  readonly
                  v-model="caratteristica_tmp"
                >
                </v-text-field>
              </v-col>

              <v-col justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Misura"
                  v-model.number="misura_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>

              <v-col justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Quantita"
                  v-model.number="quantita_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>

              <v-col justify="center" cols="3">
                <v-checkbox
                  dense
                  hide-details
                  :false-value="0"
                  label="Conforme"
                  :true-value="1"
                  v-model="conforme_tmp"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3">
                <v-btn @click="clickControllo">
                  <v-icon color="primary" large> mdi-camera </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="3">
                <div
                  id="miniatura"
                  style="
                    background-repeat: no-repeat;
                    background-size: contain;
                    border: 1px solid black;
                    height: 100px;
                    margin-top: 5px;
                    position: relative;
                    width: 100px;
                  "
                ></div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="dialog_seleziona_commessa" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Commessa
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_commessa = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_commesse_selezionabili"
                  :items="items_commesse_selezionabili"
                >
                  <template v-slot:[`item.seleziona`]="{ item }">
                    <v-btn @click="selezionaCommessa(item)" small>
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="dialog_seleziona_autocontrollo" width="unset">
      <v-card style="max-width: 900px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Commessa
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_autocontrollo = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_autocontrolli_selezionabili"
                  :items="items_autocontrolli_selezionabili"
                >
                  <template v-slot:[`item.seleziona`]="{ item }">
                    <v-btn @click="selezionaAutocontrollo(item)" small>
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog della webcam della qualità -->
    <div
      style="
        background-color: rgba(33, 33, 33, 0.46);
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 999;
      "
      v-if="controllo_webcam_visible"
    >
      <div
        style="height: 90%; left: 5%; position: absolute; top: 5%; width: 90%"
      >
        <Controllo
          @click_indietro="controllo_webcam_visible = false"
          :destinazione="'listener_controllo_qualita'"
          :immagine_standard_editor="''"
          :riferimento="'miniatura'"
          :visible="visible"
        />
      </div>
    </div>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import Controllo from "@/views/PRODUCTION/Controllo/Controllo.vue";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ControlloQualita",
  components: { Controllo, SnackbarQV },
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      // Variabili d'appoggio
      caricamento_dati: false,
      cod_commessa_search: "",
      cod_commessa_tmp: "",
      cod_articolo_search: "",
      des_fase_search: "",
      caratteristica_tmp: "",
      cod_fase_tmp: "",
      conforme_search: 2,
      conforme_tmp: 0,
      data_a: null,
      data_da: null,
      data_controllo_tmp: "",
      id_ciclo_autocontrollo_tmp: null,
      id_ciclo_autocontrollo_dettaglio_tmp: null,
      id_commessa_tmp: null,
      id_commessa_dettaglio_tmp: "",
      img_sel: null,
      img_tmp: "",
      misura_tmp: null,
      ora_controllo_tmp: "",
      quantita_tmp: null,

      // Modal
      calendario_data_da: false,
      calendario_data_a: false,
      calendario_data_controllo: false,
      calendario_ora_controllo: false,
      controllo_webcam_visible: false,
      dettaglio_immagine_visible: false,
      dialog_aggiungi_autocontrolli: false,
      dialog_seleziona_autocontrollo: false,
      dialog_seleziona_commessa: false,
      filtri_visible: false,

      // Array
      headers_autocontrolli_selezionabili: [
        {
          text: "Selezione",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
        { text: "Cod. Articolo", value: "cod_articolo", sortable: false },
        { text: "Ciclo", value: "des_ciclo", sortable: false },
        {
          text: "Caratteristica",
          value: "des_caratteristica",
          sortable: false,
        },
        { text: "Cod. Fase", value: "cod_fase", sortable: false },
        { text: "Des. Fase", value: "des_fase", sortable: false },
      ],
      headers_commesse_selezionabili: [
        {
          text: "Selezione",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
        { text: "Cod. Commessa", value: "cod", sortable: false },
      ],
      headers_registrazioni: [
        { text: "Cod. Commessa", value: "cod_commessa", sortable: false },
        { text: "Cod. Articolo", value: "cod_articolo", sortable: false },
        { text: "Des. Fase", value: "des", sortable: false },
        { text: "Caratteristica", value: "caratteristica", sortable: false },
        { text: "Esito", value: "esito", sortable: false },
        {
          text: "Operatore",
          value: "nominativo",
          sortable: false,
        },
        { text: "Data", value: "data_controllo", sortable: false },
        { text: "Presa Visione", value: "conforme", sortable: false },
        { text: "Immagine", value: "img", sortable: false },
      ],
      items_autocontrolli_selezionabili: new Array(),
      items_commesse_selezionabili: new Array(),
      items_registrazioni: new Array(),
      items_registrazioni_totali: new Array(),
    };
  },
  computed: {
    data_a_formattata() {
      return this.data_a != "" ? moment(this.data_a).format("DD/MM/YYYY") : "";
    },
    data_da_formattata() {
      return this.data_da != ""
        ? moment(this.data_da).format("DD/MM/YYYY")
        : "";
    },
    data_controllo_formattata() {
      return this.data_controllo_tmp != ""
        ? moment(this.data_controllo_tmp).format("DD/MM/YYYY")
        : "";
    },
  },
  watch: {
    data_a_search_formattata: {
      immediate: true,
      handler() {
        this.aggiornaPerData();
      },
    },
    data_da_search_formattata: {
      immediate: true,
      handler() {
        this.aggiornaPerData();
      },
    },
  },
  methods: {
    aggiornaPerData() {
      console.log("entrato aggiorna");
      if (
        this.data_da_search_formattata != "" &&
        this.data_a_search_formattata != "" &&
        this.data_da_search_formattata <= this.data_a_search_formattata
      ) {
        this.getAutocontrolli();
      }
    },
    aggiungiImg(messaggio) {
      /* Recupero l'immagine nel messaggio
       * che è un base64 non splittato. */
      let photo = messaggio.detail.img;

      // Uso il base64 per valorizzare la src di un oggetto immagine
      let img = new Image();

      img.onload = function () {
        /* Ora ho un'immagine di cui posso conoscere altezza e larghezza,
         * e dimensiono il div in maniera da accoglierla senza stretcharla.
         * Voglio che le dimensioni dell'immagine non siano mai
         * superiori a 100 px; se lo sono scalo le dimesioni.*/
        if (img.width >= img.height && img.width > 100) {
          let width_nuova = 100;
          // Proporzione -> width_nuova : img.width = height_nuova : img.height
          let height_nuova = (width_nuova * img.height) / img.width;
          document.getElementById(messaggio.detail.id).style.width =
            width_nuova + "px";
          document.getElementById(messaggio.detail.id).style.height =
            height_nuova + "px";
          img.width = width_nuova;
          img.height = height_nuova;
        } else if (img.height > img.width && img.height > 100) {
          let height_nuova = 100;
          // Proporzione -> width_nuova : img.width = height_nuova : img.height
          let width_nuova = (height_nuova * img.width) / img.height;
          document.getElementById(messaggio.detail.id).style.width =
            width_nuova + "px";
          document.getElementById(messaggio.detail.id).style.height =
            height_nuova + "px";
        } else {
          document.getElementById(messaggio.detail.id).style.width =
            img.width + "px";
          document.getElementById(messaggio.detail.id).style.height =
            img.height + "px";
        }
      };

      img.src = photo;

      document.getElementById(messaggio.detail.id).style.backgroundImage =
        'url("' + img.src + '")';
      this.img_tmp = messaggio.detail.img;
    },
    cercaCommesse() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessa",
          token: localStorage.user_token,
          cod_commessa: this.cod_commessa_tmp,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            if (res.data.lista.length === 1) {
              this.id_commessa_tmp = res.data.lista[0].id_commessa;
              this.cod_commessa_tmp = res.data.lista[0].cod_commessa;
              this.id_articolo_tmp = res.data.lista[0].id_articolo_tmp;
            } else if (res.data.lista.length > 0) {
              this.items_commesse_selezionabili = res.data.lista;
              this.dialog_seleziona_commessa = true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessuna commessa corrisponde alla ricerca."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    clickAggiungiAutocontrollo() {
      this.dialog_aggiungi_autocontrolli = true;

      this.id_commessa_tmp = null;
      this.cod_commessa_tmp = "";
      this.id_commessa_dettaglio_tmp = null;
      this.id_ciclo_autocontrollo_tmp = null;
      this.id_ciclo_autocontrollo_dettaglio_tmp = null;
      this.data_controllo_tmp = moment().format("YYYY-MM-DD");
      this.ora_controllo_tmp = "";
      this.caratteristica_tmp = "";
      this.cod_fase_tmp = "";
      this.misura_tmp = null;
      this.quantita_tmp = null;
      this.img_tmp = "";
      this.conforme_tmp = 0;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickControllo() {
      this.controllo_webcam_visible = true;
    },
    clickDettaglioImmagine(arg) {
      const request = {
        controller: "Qualita",
        method: "POST",
        richiesta: {
          action: "getautocontrolli",
          token: localStorage.user_token,
          id_controllo: arg.id_ciclo_dettaglio_misure,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.img_sel = res.data.Table1[0].img;
            this.dettaglio_immagine_visible = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
            );
          }
        })
        .catch(() => {
          // Stampo una snackbar di errore
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore critico nello scambio di dati col server.`
          );
        });
    },
    filtra() {
      /* Preparo un array temporaneo in cui
       * collezionare gli elementi filtrati */
      let elementi_tmp = [];
      this.items_registrazioni_totali.forEach((e) => {
        elementi_tmp.push(Object.assign({}, e));
      });

      // Filtro per codice commessa
      if (this.cod_commessa_search != "") {
        let res = [];
        elementi_tmp.forEach((elem) => {
          if (elem.cod_commessa.includes(this.cod_commessa_search)) {
            res.push(Object.assign({}, elem));
          }
        });
        elementi_tmp = [];
        res.forEach((e) => {
          elementi_tmp.push(Object.assign({}, e));
        });
      }

      // Filtro per codice articolo
      if (this.cod_articolo_search != "") {
        let res = [];
        elementi_tmp.forEach((elem) => {
          if (elem.cod_articolo.includes(this.cod_articolo_search)) {
            res.push(Object.assign({}, elem));
          }
        });
        elementi_tmp = [];
        res.forEach((e) => {
          elementi_tmp.push(Object.assign({}, e));
        });
      }

      // Filtro per descrizione fase
      if (this.des_fase_search != "") {
        let res = [];
        elementi_tmp.forEach((elem) => {
          if (elem.des_fase.includes(this.des_fase_search)) {
            res.push(Object.assign({}, elem));
          }
        });
        elementi_tmp = [];
        res.forEach((e) => {
          elementi_tmp.push(Object.assign({}, e));
        });
      }

      /* Filtro per conformità. Il suo valore neutro è 2, perché
       * il BE potrebbe già valorizzare la proprietà con null. */
      if (this.conforme_search != 2) {
        let res = [];
        elementi_tmp.forEach((elem) => {
          if (elem.conforme === this.conforme_search) {
            res.push(Object.assign({}, elem));
          } else {
            console.log(`no match: ${elem.conforme} ${this.conforme_search}`);
          }
        });
        elementi_tmp = [];
        res.forEach((e) => {
          elementi_tmp.push(Object.assign({}, e));
        });
      }

      // Ricostruisco gli elementi visualizzati in base agli elementi filtrati.
      this.items_registrazioni = Array.from(elementi_tmp);
    },
    getAutocontrolli() {
      const data_a_tmp = this.data_a.substr(0, 10);
      const data_da_tmp = this.data_da.substr(0, 10);

      const request = {
        controller: "Qualita",
        method: "POST",
        richiesta: {
          action: "getautocontrolli",
          token: localStorage.user_token,
          data_da: data_da_tmp,
          data_a: data_a_tmp,
        },
      };

      this.caricamento_dati = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.caricamento_dati = false;
            this.items_registrazioni = [];
            this.items_registrazioni_totali = [];
            console.log(res.data.Table1);
            this.items_registrazioni = Array.from(res.data.Table1);
            this.items_registrazioni_totali = Array.from(res.data.Table1);
          } else {
            this.caricamento_dati = false;
            this.items_registrazioni = [];
            this.items_registrazioni_totali = [];
            this.$refs.SnackbarQV.print(
              "orange",
              `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
            );
          }
        })
        .catch(() => {
          this.caricamento_dati = false;
          this.items_registrazioni = [];
          this.items_registrazioni_totali = [];
          // Stampo una snackbar di errore
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore critico nello scambio di dati col server.`
          );
        });
    },
    getCicliSelezionabili() {
      if (this.id_articolo_tmp == null || this.id_articolo_tmp == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare una commessa.");
        return;
      }

      const request = {
        controller: "Qualita",
        method: "POST",
        richiesta: {
          action: "getautocontrollicommessa",
          token: localStorage.user_token,
          id_commessa: this.id_commessa_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_autocontrolli_selezionabili = res.data.autocontrolli;
            this.dialog_seleziona_autocontrollo = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    inviaRegistrazione() {
      this.resetProperties();
      this.$emit("registrazione_inviata");
    },
    resetProperties() {},
    ripristina() {
      // Rendo invisibili i filtri e resetto le chiavi di filtro
      this.cod_commessa = "";
      this.cod_articolo = "";
      this.des_fase = "";
      this.filtri_visible = false;

      // Resetto gli elementi visualizzati in tabella
      this.items_registrazioni = [];
      this.items_registrazioni_totali.forEach((e) => {
        this.items_registrazioni.push(Object.assign({}, e));
      });

      this.filtra();
    },
    salvaRigaAutocontrolli() {
      if (
        this.id_commessa_tmp == null ||
        this.id_commessa_dettaglio_tmp == null
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare la commessa e la fase del controllo."
        );
        return;
      }

      if (this.data_controllo_tmp == "" || this.ora_controllo_tmp == "") {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare data e ora del controllo."
        );
        return;
      }

      const request = {
        controller: "Qualita",
        method: "PUT",
        richiesta: {
          action: "setciclocontrolli",
          token: localStorage.user_token,
          ciclo: [
            {
              id_ciclo_dettaglio_misure: -1,
              quantita: this.quantita_tmp == null ? 0 : this.quantita_tmp,
              misura: this.misura_tmp,
              conforme: this.conforme_tmp,
              id_commessa: this.id_commessa_tmp,
              id_commessa_dettaglio: this.id_commessa_dettaglio_tmp,
              data_controllo: `${this.data_controllo_tmp} ${this.ora_controllo_tmp}:00`,
              id_ciclo_dettaglio: this.id_ciclo_autocontrollo_dettaglio_tmp,
              img: this.img_tmp,
              validita: 1,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.dialog_aggiungi_pezzi = false;
            this.quantita_tmp = null;
            (this.img_tmp = ""), (this.id_commessa_tmp = null);
            this.cod_commessa_tmp = "";
            this.data_controllo_tmp = "";
            this.ora_controllo_tmp = "";
            this.caratteristica_tmp = "";
            this.conforme_tmp = 0;
            this.id_commessa_dettaglio_tmp = null;
            this.id_ciclo_autocontrollo_tmp = null;
            this.id_ciclo_autocontrollo_dettaglio_tmp = null;
            this.cod_fase_tmp = "";

            this.getAutocontrolli();

            this.$refs.SnackbarQV.print(
              "success",
              "Controllo registrato con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    scaleDimensions(returnValue, width, height) {
      if (width >= height && width > 100) {
        let width_nuova = 100;
        // Proporzione -> width_nuova : width = height_nuova : height
        let height_nuova = (width_nuova * height) / width;
        return returnValue === "width" ? width_nuova : height_nuova;
      } else if (height > width && height > 100) {
        let height_nuova = 100;
        let width_nuova = (height_nuova * width) / height;
        return returnValue === "width" ? width_nuova : height_nuova;
      } else {
        return returnValue === "width" ? width : height;
      }
    },
    selezionaAutocontrollo(arg) {
      this.dialog_seleziona_autocontrollo = false;
      this.cod_fase_tmp = arg.cod_fase;
      this.id_ciclo_autocontrollo_tmp = arg.id_ciclo_autocontrollo;
      this.id_ciclo_autocontrollo_dettaglio_tmp =
        arg.id_ciclo_autocontrollo_dettaglio;
      this.id_commessa_dettaglio_tmp = arg.id_commessa_dettaglio;
      this.caratteristica_tmp = arg.des_caratteristica;
    },
    selezionaCommessa(arg) {
      this.id_commessa_tmp = arg.id_commessa;
      this.cod_commessa_tmp = arg.cod;
      this.id_articolo_tmp = arg.id_articolo;
      this.dialog_seleziona_commessa = false;
    },
    setAutocontrolli(arg) {
      const request = {
        controller: "Qualita",
        method: "PUT",
        richiesta: {
          action: "setautocontrollocristal",
          token: localStorage.user_token,
          contenitore: [arg],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getAutocontrolli();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità di dialogo col server, codice errore: ${res.status}.`
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore critico nello scambio di dati col server."
          );
        });
    },
  },
  created() {},
  mounted() {
    this.data_a = moment().format("YYYY-MM-DD");
    this.data_da = moment().subtract(7, "days").format("YYYY-MM-DD");

    this.getAutocontrolli();

    document
      .getElementById("listener_controllo_qualita")
      .addEventListener("nuova_img", this.aggiungiImg);
  },
};
</script>
<style scoped>
</style>